import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Container, ListGroup, Spinner } from "react-bootstrap";
// import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import ImageElement from "components/ImageElement";

import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import { BROKER_ENDPOINT } from "apiEndpoints";

function GreatRoom() {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    imagesDetails: {
      isLoading: true,
      lists: [],
      parentId: null,
      childId: 0,
    },
  });

  const getImagesList = async (id) => {
    try {
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: true,
        },
      }));
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(id),
      });
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: false,
          lists: response?.data?.data ?? [],
          // childId: 0,
        },
      }));
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          isLoading: false,
        },
      }));
    }
  };

  const getCategoryDetails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });
      setState((prevState) => ({
        ...state,
        isLoading: false,
        lists: response?.data?.data ?? [],
        imagesDetails: {
          ...prevState.imagesDetails,
          parentId: response?.data?.data?.[0]?.child_category?.[0]?.id ?? null,
          childId:
            response?.data?.data?.[0]?.child_category?.[0]?.child_category?.[0]
              ?.id,
        },
      }));

      if (
        response?.data?.data?.[0]?.child_category?.[0]?.child_category?.[0]?.id
      ) {
        getImagesList(
          response?.data?.data?.[0]?.child_category?.[0]?.child_category?.[0]
            ?.id,
        );
      }
    } catch (error) {
      setState({
        ...state,
        isLoading: false,
      });
    }
  };

  const handleChangeOption = (parentId, childId) => {
    if (childId !== state.imagesDetails.childId) {
      setState((prevState) => ({
        ...prevState,
        imagesDetails: {
          ...prevState.imagesDetails,
          lists: [],
          parentId,
          childId,
        },
      }));
      getImagesList(childId);
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getCategoryDetails();
    }
  }, []);

  return (
    <>
      <div className="mainContent_inner ps-0 h-100vh greatRoom">
        <Container fluid className="position-relative">
          <div className="row">
            <Col md={6} className="p-0">
              {state.imagesDetails.isLoading ? (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  <Spinner />
                </div>
              ) : !state.imagesDetails.isLoading &&
                (state.imagesDetails?.lists?.length > 0 ||
                  location.state?.primary_media) ? (
                <div className="modelGallery_left commonLeftImg">
                  <div className="boxImage">
                    <ImageElement
                      imageFor="user"
                      previewSource={
                        state.imagesDetails.lists?.[state.imagesDetails.childId]
                          ?.primary_media ?? location.state?.primary_media
                      }
                      className="h-100vh object-fit-cover w-100 pt-5 pt-md-0"
                      alt="modal-gallery"
                    />
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <ImageElement
                    imageFor="user"
                    previewSource="landing.jpg"
                    className="h-100vh object-fit-cover w-100 pt-5 pt-md-0"
                    alt="modal-gallery"
                    />
                </div>
              )}
            </Col>
            <Col
              md={6}
              className="d-flex flex-column align-items-center"
            >
              <div className="header w-100 d-flex align-items-center pe-1">
                <div className="header_title mx-auto">
                  <h1 className="mb-0">Great Room</h1>
                </div>
                <Link className="header_logo" to={userRouteMap.LANDING.path}>
                  <ImageElement
                    imageFor="user"
                    source="logo.svg"
                    className="img-fluid"
                  />
                </Link>
              </div>
              <div className="d-flex flex-column justify-content-around align-items-center multiList multiList-tab multiList-scrollable">
                <div
                  className={
                    state.lists.length > 0 ? "text-center innerScroll px-3" : ""
                  }
                >
                  <div className="innerSubHead">
                    <div className="d-flex flex-column align-items-center">
                      <div className="text-center">
                        {state?.isLoading ? (
                          <div className="d-flex justify-content-center align-items-center m-auto">
                            <Spinner />
                          </div>
                        ) : state?.lists?.length > 0 ? (
                          state?.lists.map((item, parentIndex) => (
                            <div key={parentIndex}>
                              <h2 className="text-uppercase innerHead text-center">
                                {item.name}
                              </h2>
                              {item?.child_category?.map(
                                (childItem, childId) => (
                                  <ListGroup key={childId}>
                                    <ListGroup.Item className="multiList_item mb-lg-5 mb-4">
                                      <Link
                                        className={`multiList_item_tab ${
                                          state.imagesDetails.parentId ===
                                          childItem?.id
                                            ? "active-heading"
                                            : ""
                                        }`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {childItem?.name}
                                      </Link>
                                      <div className="d-flex flex-wrap subList justify-content-center">
                                        {childItem?.child_category?.map(
                                          (grandChildItem, grandchildId) => (
                                            <Link
                                              key={grandchildId}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleChangeOption(
                                                  childItem?.id,
                                                  grandChildItem?.id,
                                                );
                                              }}
                                              className={`subList_tab subList_tab${
                                                state.imagesDetails.childId ===
                                                grandChildItem?.id
                                                  ? "-autoActive"
                                                  : ""
                                              }`}
                                            >
                                              {grandChildItem?.name}
                                            </Link>
                                          ),
                                        )}
                                      </div>
                                    </ListGroup.Item>
                                  </ListGroup>
                                ),
                              )}
                            </div>
                          ))
                        ) : (
                          <div className="d-flex justify-content-center align-items-center vh-100">
                            No data found
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Link
                className="commonBack text-uppercase d-block h-auto"
                onClick={() => navigate(-1)}
              >
                <em className="icon-back" />
                <span className="d-block">Back</span>
              </Link>
            </Col>
          </div>
        </Container>
      </div>
    </>
  );
}

export default GreatRoom;
